<section id="region-maint">    
    <div class="mtn-container">
        <div class="mtn-title">
            <p>{{ moduleName }}</p>
        </div>
        <!-- Container for Earthquake Zone Table using prime ng -->
        <div class = 'table-user'>
            <osp-table [tblConfig]="regionTblConfig" (onRowClick)="onRowClick($event)"></osp-table>
        </div>
        <!-- Loading Animation -->
        <div id="region-maintenance-loading">
            <div class="form-loader"></div>
        </div>
        <div class="form-content" *ngIf="showForm">
            <form [formGroup]="forms.regionForm" class="form">
                <div id="region-error-message"></div>
                <div class="form-container-grid">
                    <div class="field">
                        <label>Region Code</label>
                    </div>
                    <div class="">
                        <input formControlName="regionCdDisp" type="text" readonly>
                    </div>
                    <div class="field required">
                        <label>Active</label>
                    </div>
                    <div class="">
                        <select formControlName="activeTag">
                            <option *ngFor="let activeType of selections.activeTypes" [value]="activeType.cd">
                                {{activeType.name}}
                            </option>
                        </select>
                    </div>

                    <div class="field required">
                        <label>Region Short Description</label>
                    </div>
                    <div class="">
                        <input formControlName="regShortDesc" type="text" maxlength="25">
                    </div>
                    <div class="field required">
                        <label>BPIMS Code</label>
                    </div>
                    <div class="">
                        <input formControlName="bmCode" type="text" maxlength="8">
                    </div>

                    
                    <div class="field required">
                        <label>Region Long Description</label>
                    </div>
                    <div class="span">
                        <input formControlName="regionDesc" type="text" maxlength="1000">
                    </div>
                    
                    <div class="field">
                        <label>Remarks</label>
                    </div>
                    <div class="span">
                        <input formControlName="remarks" type="text" maxlength="1000">
                    </div>

                    <div class="field">
                        <label>Last Update User</label>
                    </div>
                    <div class="">
                        <input type="text" readonly formControlName="userID">
                    </div>
                    <div class="field">
                        <label>Last Update</label>
                    </div>
                    <div class="">
                        <input type="text" readonly formControlName="lastUpdate">
                    </div>
                </div>
            </form>
            <div class="btn-row">
                <button *ngIf="btns.region.updateDisabled" class="btn btn2" type="button" (click)='onAdd()'>ADD</button>
                <button *ngIf="!btns.region.updateDisabled" class="btn btn2" type="button" (click)='onUpdate()'>UPDATE</button>
                <button class="btn btn2" type="button" [disabled]='btns.region.deleteDisabled' (click)='onDelete()'>DELETE</button>
            </div>
            <div class="mtn-title"></div>
            <div class="btn-row">
                <button class="btn btn2" type="button" [disabled]='btns.region.saveDisabled' (click)='onSave()'>SAVE</button>
            </div>
        </div>
    </div>
</section>